import { memo } from 'react';
import { makeStyles, tokens } from '@fluentui/react-components';
import type { ProjectAllocationDeficit } from '../state';

type AllocationDeficitListProps = {
    deficits: ProjectAllocationDeficit[];
};

const useStyles = makeStyles({
    table: {
        width: '100%',
        borderCollapse: 'collapse',
        tableLayout: 'fixed',
    },
    th: {
        textAlign: 'left',
        paddingTop: '8px',
        paddingBottom: '8px',
        paddingLeft: '10px',
        paddingRight: '10px',
        borderBottomWidth: '2px',
        borderBottomStyle: 'solid',
        borderBottomColor: tokens.colorNeutralStroke1,
        fontWeight: 600,
        width: '40%',
    },
    thNumeric: {
        textAlign: 'right',
        paddingTop: '8px',
        paddingBottom: '8px',
        paddingLeft: '10px',
        paddingRight: '10px',
        borderBottomWidth: '2px',
        borderBottomStyle: 'solid',
        borderBottomColor: tokens.colorNeutralStroke1,
        fontWeight: 600,
        width: '20%',
    },
    td: {
        paddingTop: '6px',
        paddingBottom: '6px',
        paddingLeft: '10px',
        paddingRight: '10px',
        borderBottomWidth: '1px',
        borderBottomStyle: 'solid',
        borderBottomColor: tokens.colorNeutralStroke2,
    },
    tdNumeric: {
        paddingTop: '6px',
        paddingBottom: '6px',
        paddingLeft: '10px',
        paddingRight: '10px',
        borderBottomWidth: '1px',
        borderBottomStyle: 'solid',
        borderBottomColor: tokens.colorNeutralStroke2,
        textAlign: 'right',
        fontVariantNumeric: 'tabular-nums',
    },
    nameCell: {
        overflowX: 'hidden',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap',
        maxWidth: '200px',
    },
});

export const AllocationDeficitList = memo(function AllocationDeficitList({ deficits }: AllocationDeficitListProps) {
    const styles = useStyles();

    if (deficits.length === 0) return null;

    return (
        <table className={styles.table}>
            <thead>
                <tr>
                    <th className={styles.th}>Project</th>
                    <th className={styles.thNumeric}>Allocated</th>
                    <th className={styles.thNumeric}>Registered</th>
                    <th className={styles.thNumeric}>Below</th>
                </tr>
            </thead>
            <tbody>
                {deficits.map(({ project, allocated, registered, below }) => (
                    <tr key={project.id}>
                        <td className={`${styles.td} ${styles.nameCell}`}>
                            <span title={project.name}>{project.name}</span>
                        </td>
                        <td className={styles.tdNumeric}>{allocated}</td>
                        <td className={styles.tdNumeric}>{registered}</td>
                        <td className={styles.tdNumeric}>{below}</td>
                    </tr>
                ))}
            </tbody>
        </table>
    );
});
